/**
 * PATH: packages/email-hub/src/feature/pages/inbox-page/InboxPageFrame.tsx
 * FILE_ID: EMAIL-INBOX-FRAME-001
 * PURPOSE: Assemble Inbox surfaces from the behavior controller.
 */

import { EmailContextMenuProvider } from '../../components/EmailContextMenu'
import { contextActionIds } from '../inboxSelection'
import type { InboxPageProps } from './contracts'
import { InboxListPane } from './InboxListPane'
import { InboxOverlays } from './InboxOverlays'
import { InboxReaderPane } from './InboxReaderPane'
import { useInboxPageController } from './useInboxPageController'

export function InboxPageFrame(props: InboxPageProps = {}) {
  const vm = useInboxPageController(props)

  return (
    <EmailContextMenuProvider
      resolveContextIds={(email) => {
        const next = contextActionIds({
          orderedIds: vm.dedupedEmails.map((row) => row.id),
          selected: vm.selectedIds,
          clickedId: email.id,
        })
        if (next.replaced) vm.setSelectedIds(next.selection)
        return next.ids
      }}
      onRefetch={vm.refetchPreservingScroll}
      onPatchLocal={vm.updateEmailLocal}
      onResolvedLocal={vm.handleEmailResolved}
      inviteMembers={vm.inviteMembers ?? undefined}
    >
      {({ handleContextMenu, contextMenuNode }) => (
        <div className="flex h-full" ref={vm.twoPaneRef}>
          <InboxListPane vm={vm} handleContextMenu={handleContextMenu} />
          <InboxReaderPane vm={vm} handleContextMenu={handleContextMenu} />
          <InboxOverlays vm={vm} contextMenuNode={contextMenuNode} />
        </div>
      )}
    </EmailContextMenuProvider>
  )
}
